module.exports = __webpack_public_path__ + "img/xaas-occc.c9f1e3d.svg";